


export function resourceURL(resource: string): string {
    return `/_resources/` + (resource.startsWith('/') ? resource.substr(1) : resource);
}